import type { RfqViewState } from "./rfq-view-types";
import type { Rfq } from "../../domain/rfq-types";
import { eligibilityReasonLabel } from "./rfq-presentation";

type Props = Pick<RfqViewState,
  "rfq" |
  "candidates" |
  "selected" |
  "setSelected"
> & { rfq: Rfq };
export function RfqCandidates({
  rfq,
  candidates,
  selected,
  setSelected,
}: Props) {
  return (
    candidates.length ? (
      <div className="data-table-wrap">
        <table className="data-table">
          <thead>
            <tr>
              <th>Tedarikçi</th>
              <th>Sunucu uygunluğu</th>
              <th>Seçim</th>
            </tr>
          </thead>
          <tbody>
            {candidates.map((candidate) => (
              <tr key={candidate.id}>
                <td>{candidate.name}</td>
                <td>
                  {candidate.eligible
                    ? "Uygun"
                    : candidate.blockingReasons
                        .map(eligibilityReasonLabel)
                        .join(", ")}
                </td>
                <td>
                  <input
                    aria-label={`${candidate.name} seç`}
                    type="checkbox"
                    disabled={
                      !candidate.eligible || rfq.status !== "DRAFT"
                    }
                    checked={selected.includes(candidate.id)}
                    onChange={(event) =>
                      setSelected((current) =>
                        event.target.checked
                          ? [...current, candidate.id]
                          : current.filter((id) => id !== candidate.id),
                      )
                    }
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    ) : (
      <p>Bu kapsam için tedarikçi adayı bulunamadı.</p>
    )
  );
}
